import 'bootstrap';
import 'jquery-drawer';
import Swiper from 'swiper';
(function($) {

    var url = location.href// URLの取得
    var path = location.pathname// パスの取得
    var param = location.search// パラメーターの取得
    var anc = location.hash// ページ内アンカーの取得
    path = path.replace( 'sample_iemamori/', '' );// 本番環境では削除
    if ( url == 'http://example.com/' ){}
    if ( path.match(/cart\//) ){}
    if ( path == '/login.html' ){
        Action.checkFullPageBackgroundImage();
    }
    if ( param == '?search=123' ){}
    if ( anc == '#anchor01' ){}

    $('.drawer').drawer();

    var swiper = new Swiper('#view .swiper-container', {
        spaceBetween: 40,
        slidesPerView:3.3,
        centeredSlides: true,
        effect: 'slide',
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#view .swiper-button-next',
            prevEl: '#view .swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            578: {
                spaceBetween: 10,
                slidesPerView:1.4,
            }
        },
        loop:true
    });
    var swiper2 = new Swiper('#facilities .swiper-container', {
        spaceBetween: 40,
        slidesPerView:3.3,
        centeredSlides: true,
        effect: 'slide',
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '#facilities .swiper-button-next',
            prevEl: '#facilities .swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            578: {
                spaceBetween: 10,
                slidesPerView:1.4,
            }
        },
        loop:true
    });

})(jQuery);import 'bootstrap';

$(function(){
    $('a.page_link').on('click',function(){
        var speed = 500;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top - 60;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });
    $('.faq dt').each(function(){
        $(this).on('click',function(){
            $(this).next('dd').slideToggle();
            $(this).toggleClass('active');
        });
    });
    $('#search_shop').on('change',function(){
        var link = $(this).find('option:selected').val();
        window.location.href = link;
    });
    $('.tel_num').each(function(){
        $(this).on('click',function(){
            if($(window).innerWidth() < 768){
                window.location.href = 'tel:06-6567-8352';
            }
        });
    });
    var float_flg = false;
    $(window).on('load',function(){
        if($(window).outerWidth() < 768){
            float_flg = true;
        }
    });
    $(window).on('resize',function(){
        if($(window).outerWidth() < 768){
            float_flg = true;
        }else{
            float_flg = false;
        }
    });
    $(window).on('scroll',function(){
        if(float_flg && $(window).scrollTop() > 500){
            $('#sp_floating').fadeIn()
        }else{
            $('#sp_floating').fadeOut()
        }
    });
});